import { Component, effect, inject, ChangeDetectionStrategy } from '@angular/core';
import { Register, SecureComponent } from '@xanadu/core';
import { ContentModel, PrototypeModel, Site, ViewFields } from '@xanadu/model';
import { AspectCache, PrototypeCache } from '@xanadu/cache';

@Component({
    selector: 'app-site-panel',
    templateUrl: './site-panel.component.html',
    styleUrls: ['./site-panel.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
@Register('site-panel')
export class SitePanelComponent extends SecureComponent<Site> {
    private readonly aspectCache = inject(AspectCache);
    private readonly prototypeCache = inject(PrototypeCache);

    tabSite = { caption: 'Site', active: true, hidden: false };

    prototypeModel?: PrototypeModel;
    contentModel?: ContentModel;

    metaPrototype: any = {};

    constructor(
    ) {
        super();

        effect(() => {
            const model = this.model();
            const site = this.node();
            const aspects = this.aspectCache.signal();
            const prototypes = this.prototypeCache.signal();

            if (site && prototypes) {
                const viewFields = new ViewFields(site, model.custome, prototypes, aspects);

                this.prototypeModel = viewFields.prototypeModel;
                this.contentModel = viewFields.contentModel;
            }
        });
    }

    protected override setup(site: Site): void {
        super.setup(site);

        this.tabs = this.permissible
            ? [this.tabSite, this.tabSecurity, this.tabAccess]
            : [this.tabSite];

        this.tabSelected = this.tabSite;
    }

    protected override load(site: Site, form: any): string | undefined {
        super.load(site, form);

        site.data = form;
        return;
    }

    onPermission(): void {
        const site = this.node();
        if (site) {
            this.doPermission(Site, site);
        }
    }

    onAdmission(): void {
        const site = this.node();
        if (site) {
            this.doAdmission(Site, site);
        }
    }
}
